import { c as _c } from "react/compiler-runtime";
import NoWorkspacesIcon from "@assets/illustrations/no_workspaces.svg";
import { SphereSupportLink } from "@components/common/sphere-support-link";
import { ContactSupportLocations } from "@custom-types/types";
import { ErrorPageBase } from "@pages/error-page-base";

/**
 * Component to be shown inside the workspace selector page when the user does not have access to any workspace.
 */
export function NoWorkspace() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ErrorPageBase iconImg={NoWorkspacesIcon} title="No workspaces found" shouldShowSupportBtn={true}>You do not have access to a workspace. If you are having trouble accessing your workspace or want to buy a subscription, please contact{" "}<SphereSupportLink location={ContactSupportLocations.noWorkspace} /></ErrorPageBase>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}